import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { ExportType, ReportMenu } from '../../../constants'
import { authService, reportService } from '../../../services'
import { exportFile, formatter } from '../../../util'

// UI
import { Button, List, Page, Pager } from '../../../components'
import notify from '../../../components/Notification'
import Skeleton from 'antd/lib/skeleton'
import Icon from 'antd/lib/icon'
import Spin from 'antd/lib/spin'
import Tooltip from 'antd/lib/tooltip'

import './styles.css'
import { connect } from 'react-redux'
import { settingOtherService } from '../../../services/setting'
import { Form, Input } from 'antd';
const { Item: FormItem } = Form
const pageSize = 50

export class ReportClientLeaves extends Component {
  constructor (props) {
    super(props)
    this.state = {
      leaveList: { list: [], total: 0 },
      leaveOverMonthList: { list: [], total: 0 },
      currentPage: 1,
      isLoaded: false,
      loading: false,
      loadingExport: false,
      loadingList: false,
      settings: {},
    }
  }

  componentDidMount () {
    this.fetchList()
    this.fetchOtherSettings()
  }

  render () {
    const { currentPage, loading, loadingExport, loadingList, leaveList, leaveOverMonthList, total, settings } = this.state
    const { form } = this.props
    const { getFieldDecorator } = form
    const longFormItemLayout = {
      labelCol: { sm: 6, md: 6, lg: 4 },
      wrapperCol: { sm: 10, md: 10, lg: 14 }
    }

    const leaveColumns = [
      {
        title: 'Client',
        width: 4,
        render: ({ member_id, member_fullname }) => <a href={`/clients/${member_id}`} rel='noopener noreferrer' target='_blank'>{member_fullname}</a>
      },
      {
        title: 'Funder(s)',
        width: 5,
        key: 'member_funders'
      },
      {
        title: 'Leave',
        width: 6,
        render: ({ leave_is_ufn, leave_start_date, leave_end_date, leave_duration_day_count }) => {
          const text = leave_is_ufn
            ? `From ${formatter.toShortDate(leave_start_date)} Until Further Notice`
            : `${leave_duration_day_count} day${Number(leave_duration_day_count) === 1 ? '' : 's'} from ${formatter.toShortDate(leave_start_date)} to ${formatter.toShortDate(leave_end_date)}`
          return <div>{text}</div>
        }
      },
      {
        title: 'Memo',
        width: 6,
        render: ({ leave_memo }) => <div>{leave_memo}</div>
      },
      {
        title: 'Affected Jobs',
        width: 3,
        render: ({ leave_type_id, leave_id, impacted_jobs, total_jobs }) => {
          return leave_id && Number(total_jobs) > 0
            ? <a style={{ color: '#dd4444' }} href={`/clients/${leave_type_id}/leave/${leave_id}?notify`}>{impacted_jobs} job{Number(impacted_jobs) === 1 ? '' : 's'}</a>
            : null
        }
      }
    ]

    const leaveOverMonthColumns = [
      {
        title: 'Client',
        width: 4,
        render: ({ member_id, member_fullname }) => <a href={`/clients/${member_id}`} rel='noopener noreferrer' target='_blank'>{member_fullname}</a>
      },
      {
        title: 'Funder(s)',
        width: 5,
        key: 'member_funders'
      },
      {
        title: 'Leave',
        width: 6,
        render: ({ leave_is_ufn, leave_start_date, leave_end_date, leave_duration_day_count }) => {
          const text = leave_is_ufn
            ? `From ${formatter.toShortDate(leave_start_date)} Until Further Notice`
            : `${leave_duration_day_count} day${Number(leave_duration_day_count) === 1 ? '' : 's'} from ${formatter.toShortDate(leave_start_date)} to ${formatter.toShortDate(leave_end_date)}`
          return <div>{text}</div>
        }
      },
      {
        title: 'Memo',
        width: 6,
        render: ({ leave_memo }) => <div>{leave_memo}</div>
      },
      {
        title: 'As Of Today',
        width: 3,
        render: ({ leave_day_count_from_today }) => `${formatter.humanizeDuration(leave_day_count_from_today, '')}`
      }
    ]


    return (
      <Page.Body>
        <Page.Left>
          <Page.Menu title='Home' menu={ReportMenu} />
        </Page.Left>

        <Page.Content full>
          <Page.Header title={`Client's Leave`} >
            { !loading
              ? <Button key={'export'} feedback={loadingExport} onClick={() => this.handleExport()}>
                Export
              </Button>
              : null }
            { !loading
              ? this.hasAccess('listRecipients') 
              ? this.hasAccess('updateRecipient') ?
              <Button ghost key={'save'} feedback={loadingExport} onClick={() => this.handleSave()}>
                Save
              </Button> : null : null
              : null }

          </Page.Header>

          <div className='admin-list'>
            { !loading
              ? this.hasAccess('listRecipients') 
              ? <Form {...longFormItemLayout}>
                   <FormItem label="Weekly Email Recipients">
                          {getFieldDecorator('client_leave_email', {
                          initialValue: settings.client_leave_email,
                          rules: [{ required: true, message: 'Please enter weekly email report recipients' }]
                            })
                          (<Input />)
                          }
                   </FormItem>
                 </Form> : null
              : null }   
          </div>

          <div className='admin-list'>
            <Skeleton loading={loading} active>
              <div className='report-title'>{`Client's Leave `} <span className='report-tag'>{leaveList.total}</span></div>
              <List cols={leaveColumns} rows={leaveList.list} />

              <div className='report-title'>{`Client's Leave Over A Month `} <span className='report-tag'>{leaveOverMonthList.total}</span></div>
              <List cols={leaveOverMonthColumns} rows={leaveOverMonthList.list} />
            </Skeleton>
          </div>
        </Page.Content>
      </Page.Body>
    )
  }

  fetchList () {
    const { currentPage, isLoaded, loading } = this.state
    this.fetchClientLeave({currentPage, isLoaded, loading})
  }

  async fetchClientLeave ({ currentPage, isLoaded = true, loading }) {
    if (this.hasAccess('readClientReport')) {
      if (isLoaded) {
        this.setState({ loadingList: true })
      } else {
        this.setState({ loading: true })
      }

      try {
        const { leaves, leavesOverMonth } = await reportService.getListByAll(ExportType.REPORT.CLIENT_LEAVE)

        this.setState({
          leaveOverMonthList: leavesOverMonth,
          leaveList: leaves,
          loading: false,
          loadingList: false,
          isLoaded: true
        }, () => this.toTop())
      } catch (e) {
        notify.error('Unable to get Client Leaves Report', 'Please try again later.')
        this.setState({ loading: false, loadingList: false, isLoaded: false  })
      }
    }
  }

  fetchOtherSettings = async () => {
    try {
      this.setState({ loading: true })
      const settings = await settingOtherService.listByPage(1, 0)

      this.setState({ settings: settings.list[0], loading: false })
    } catch (e) {
      notify.error('Unable to load successfully', 'Unable to load settings successfully. Please try again later.')
    }
  }

  handleSave = () => {
    const { form } = this.props
    const { settings } = this.state
    const { validateFields } = form

    validateFields(async (errors, values) => {
      if (!errors) {
        const { id } = settings
        this.setState({ loadingForm: true })

        try {
          let response = await settingOtherService.save(id, values)

          this.setState({ loadingForm: false })
          
          if (response.id) {
            notify.success('Saved successfully', `Settings saved successfully.`)
          } else {
            notify.error('Unable to save successfully', `Unable to save settings successfully. Please try again later.`)
          }
        } catch (e) {
          notify.error('Unable to save successfully', `Unable to save settings successfully. Please try again later.`)
          this.setState({ loadingForm: false })
        }
      }
    })
  }

  onChangePage (page) {
    this.setState({ currentPage: page }, () => {
      this.fetchList()
    })
  }

  handleExport = () => {
    const { loadingExport, loading, loadingList } = this.state

    if (loadingExport || loading || loadingList || !this.hasAccess('readClientReport')) return

    this.setState({ loadingExport: true })

    setTimeout(async () => {
      const r = await exportFile.fetchReportExport(ExportType.REPORT.CLIENT_LEAVE)
      this.setState({ loadingExport: false })
    }, 4000)
  }

  hasAccess (accessLevel) {
    return authService.hasAccess(accessLevel)
  }

  toTop () {
    if(window) {
      window.scrollTo(0, 0)
    }
  }
}

const mapDispatchToProps = {
}

const mapStateToProps = (state) => {
  return state
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Form.create()(ReportClientLeaves))
